import { useInfiniteQuery } from '@tanstack/react-query';

import { type CommonQueryArgs } from '@pkg/hooks';
import { useGetSlugChain } from '@pkg/hooks/tokens/useGetSlugChain';

import { type SupportedTokens } from '@app/client';
import { callGetCollectionTraits } from '@app/client/resources/daas';

import { DAAS_COLLECTION_TRAITS } from '../metadata/daasMetadataQueries';

interface GetCollectionTraitsArgs extends CommonQueryArgs {
    chain?: SupportedTokens | string;
    collectionSlug?: string;
    trait_name?: string;
}
export function useGetCollectionTraits(args?: GetCollectionTraitsArgs) {
    const { chain, collectionSlug, trait_name, disabled } = args || {};
    const querySlugString = useGetSlugChain({
        type: 'daas',
        unified: true,
        providedChain: chain,
        providedSlug: collectionSlug,
    });
    const cache = [DAAS_COLLECTION_TRAITS, querySlugString, trait_name];
    const limit = args?.limit || 500;
    const queries = trait_name ? { limit, trait_name } : { limit };
    return useInfiniteQuery(
        cache,
        ({ signal, pageParam }) =>
            callGetCollectionTraits({
                settings: { signal },
                chainSlug: querySlugString,
                query: {
                    ...queries,
                    ...(pageParam ? { continuation: pageParam } : {}),
                },
            }),
        {
            retry: false,
            keepPreviousData: true,
            enabled: Boolean(querySlugString) && !disabled,
            getNextPageParam: (params) => {
                return params?.continuation;
            },
        },
    );
}
